import React from "react";
import Tile from "../../components/Tile/Tile";
import "./FindInternshipstyle.css";
import { ContentfulTileProps } from "../../utils/contentful-helpers";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";
import { toggleResourceBookmark } from "../../stores/bookmarks/resourceBookmarksSlice";


export interface InternshipTilesProps {
  resourceTiles: ContentfulTileProps[];
}

const InternshipTiles = ({
  resourceTiles,
}) => {
  const dispatch = useAppDispatch();
  const { userId, sessionId } = useAppSelector((state) => state.session);
  const bookmarks = useAppSelector((state) => state.resourceBookmarks.bookmarks);

  const handleBookmarkInternship = (resourceTile: ContentfulTileProps) => {
    const { id, title, description } = resourceTile;
    const isBookmarked = bookmarks.some((bookmark) => bookmark.resourceId === id);
    const eventData = bookmarkEventBuilder(!isBookmarked, userId, sessionId, "InternshipTile", title, {
      bookmarkedResource: {
        title: title,
        description: JSON.stringify(description),
        resource_id: id,
      },
    });
    sendEvent(eventData);

    dispatch(
      toggleResourceBookmark({ userId, resourceId: id })
    );
  };
  return (
    <div className="internship-wrapper">
      <div className="internship-container">
        {resourceTiles.map((tile) => (
          <Tile
            key={tile.id}
            id={tile.id}
            title={tile.title}
            description={tile.description}
            thumbnail={tile.thumbnail}
            url={tile.url}
            isResearchPage={false}
            onBookmark={() => {
              handleBookmarkInternship(tile);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default InternshipTiles;
